module.exports = __webpack_public_path__ + "img/banner1.4c9f64f.jpg";